export default import.meta.ROLLUP_FILE_URL_cres4tNw;